import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, reactive } from "vue";
import { ElMessageBox } from "element-plus";
import type { FormInstance, FormRules } from "element-plus";


export default /*@__PURE__*/_defineComponent({
  __name: 'CreateAppModal',
  props: {
    modelValue: { type: Boolean },
    loading: { type: Boolean }
  },
  emits: ["update:modelValue", "submit"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const formRef = ref<FormInstance>();

const form = reactive({
  title: "",
  bundle: "",
});

const rules: FormRules = {
  title: [
    {
      required: true,
      message: "Title is required",
      trigger: ["blur", "change"],
    },
    {
      min: 2,
      message: "Title must be at least 2 characters",
      trigger: ["blur", "change"],
    },
  ],
  bundle: [
    {
      required: true,
      message: "Bundle is required",
      trigger: ["blur", "change"],
    },
    {
      pattern: /^[a-zA-Z][a-zA-Z0-9]*(\.[a-zA-Z][a-zA-Z0-9]*)+$/,
      message: "Bundle must be a valid identifier (e.g. com.example.app)",
      trigger: ["blur", "change"],
    },
  ],
};

const resetForm = () => {
  form.title = "";
  form.bundle = "";
  formRef.value?.resetFields();
};

const handleSubmit = async () => {
  if (!formRef.value) return;
  const valid = await formRef.value.validate().catch(() => false);
  if (!valid) return;

  await ElMessageBox.confirm(
    `App <b>${form.title}</b> with bundle <b>${form.bundle}</b> will be created. This action is irreversible.`,
    "Confirm creation",
    {
      confirmButtonText: "Create",
      cancelButtonText: "Cancel",
      dangerouslyUseHTMLString: true,
      type: "warning",
    }
  ).then(() => {
    emit("submit", { title: form.title, bundle: form.bundle });
  });
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": __props.modelValue,
    title: "Create App",
    width: "480px",
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:modelValue', $event))),
    onOpen: resetForm
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:modelValue', false)))
      }, {
        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
          _createTextVNode("Cancel", -1)
        ]))]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        loading: __props.loading,
        onClick: handleSubmit
      }, {
        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
          _createTextVNode(" Create ", -1)
        ]))]),
        _: 1
      }, 8, ["loading"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref_key: "formRef",
        ref: formRef,
        model: form,
        rules: rules,
        "label-position": "top"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "Title",
            prop: "title"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: form.title,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.title) = $event)),
                placeholder: "Enter app title"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "Bundle",
            prop: "bundle"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: form.bundle,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.bundle) = $event)),
                placeholder: "com.example.app"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})